/**
 * @param {File} file
 * @returns {String} base64
 */
export const getBase64 = (file, callback) => {
  const reader = new FileReader()
  reader.readAsDataURL(file)
  reader.onload = () => callback(reader.result)
  reader.onerror = (error) => console.error('getBase64: ', error)
}

/**
 * @param {Object} documentInfo
 * @param {String} documentInfo.url
 * @param {String} documentInfo.filename
 * @param {String} documentInfo.contentType
 * @returns {File}
 */
export const getFileFromUrl = async (documentInfo) => {
  const { url, filename, contentType } = documentInfo
  const response = await fetch(url)
  const data = response.blob()
  const newFile = new File([data], filename, {
    type: contentType
  })

  return newFile
}
